<template>
  <div>
    <Head :title="`${form.first_name} ${form.last_name}`" />
    <div class="flex justify-start mb-8 max-w-3xl">
      <h1 class="text-3xl font-bold">
        <Link class="text-orange-600 hover:text-orange-500" href="/users">Users</Link>
        <span class="text-orange-600 font-medium">/</span>
        {{ form.first_name }} {{ form.last_name }}
      </h1>
      <img v-if="user.photo" class="block ml-4 w-8 h-8 rounded-full" :src="user.photo" />
    </div>
    <trashed-message v-if="user.deleted_at" class="mb-6" @restore="restore"> This user has been deleted. </trashed-message>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.first_name" :error="form.errors.first_name" class="pb-8 pr-6 w-full lg:w-1/2" label="First name" />
          <text-input v-model="form.last_name" :error="form.errors.last_name" class="pb-8 pr-6 w-full lg:w-1/2" label="Last name" />
          <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-full" label="Email" />
          <!--<select-input v-model="form.role" :error="form.errors.role" class="pb-8 pr-6 w-full lg:w-full" label="Group">
            <option v-for="role in user.roles" :key="role.id" :value="role">{{ role }}</option>
          </select-input> -->
          <div class="w-full lg:w-full pb-2 pr-7 mb-8">
            <p class="pt-1 pb-1 mb-1">Groups:</p>
            <multiselect
              id="role"
              v-model="form.roles"
              placeholder="Search groups"
              :options="groups"
              :clear-on-select="false"
              :preserve-search="true"
              :searchable="true"
              mode="tags"
              class="mt-1"
              :close-on-select="false"
              :create-option="true"
              :error="form.errors.roles"
              :style="form.errors.roles ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
            />
            <div v-if="form.errors.roles" class="form-error">{{ form.errors.roles }}</div>
          <!--</div> -->
          </div>
          <!-- <file-input v-model="form.photo" :error="form.errors.photo" class="pb-8 pr-6 w-full lg:w-1/2" type="file" accept="image/*" label="Photo" /> -->
          <div class="w-full lg:w-full pb-2 pr-7 mb-8">
            <p class="pt-1 pb-1 mb-1">User specific permissions:</p>
            <multiselect
              id="permission"
              v-model="form.permissions"
              placeholder="Search Permissions"
              :options="permissions"
              :clear-on-select="false"
              :preserve-search="true"
              :searchable="true"
              mode="tags"
              class="mt-1"
              :close-on-select="false"
              :create-option="true"
              :error="form.errors.permissions"
              :style="form.errors.permissions ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
            />
            <div v-if="form.errors.permissions" class="form-error">{{ form.errors.permissions }}</div>
          <!--</div> -->
          </div>
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="!user.deleted_at" class="text-red-600 hover:underline mr-3" tabindex="-1" type="button" @click="destroy">Delete User</button>
          <button class="mr-3 text-orange-600 hover:underline" tabindex="-1" type="button" @click="resetPassword">Reset Password</button>
          <loading-button :loading="form.processing" class="btn-orange ml-auto" type="submit">Update User</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
// import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Multiselect from '@vueform/multiselect'

export default {
  components: {
    // FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    Multiselect,
  },
  layout: Layout,
  props: {
    user: Object,
    permissions: Object,
    groups: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        email: this.user.email,
        password: '',
        role: this.user.role,
        roles: this.user.roles,
        permissions: this.user.permissions,
        //owner: this.user.owner,
        //photo: null,
      }),
    }
  },
  methods: {
    update() {
      this.form.post(`/users/${this.user.id}`, {
        onSuccess: () => this.form.reset('password', 'photo'),
      })
    },
    destroy() {
      if (confirm('Are you sure you want to delete this user?')) {
        this.$inertia.delete(`/users/${this.user.id}`)
      }
    },
    resetPassword() {
      if (confirm('Are you sure you want to send a password reset link to this user?')) {
        this.$inertia.post(`/users/${this.user.id}/reset/password`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this user?')) {
        this.$inertia.put(`/users/${this.user.id}/restore`)
      }
    },
  },
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style type="text/css">
  .multiselect-option.is-selected.is-pointed {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
  .multiselect-option.is-selected {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
</style>
